import { createGenericStore } from '../store/genericStore';
import { OrganizationUser } from './types';

export const useOrgUserStore = createGenericStore<OrganizationUser>();
